import axios from "axios";

import authHeader from "./authHeader";
import { api, baseUrl, host, settingsUrl, tenant, userApi } from "./endpoints";
import { CalCulateOrderPrice, NewCustomerArgs, NewCustomerEligibleArgs, PayAsGuestArgs, SelfRegisterArgs } from "../store/login-reducer/types";

let timeoutId: ReturnType<typeof setTimeout>;
export const sessionTimeout = 60 * 60 * 1000;

export const startSessionTimer = () => {
    clearTimer() // Clear any previous timeout

    sessionStorage.setItem('sessionStartTime', new Date().getTime().toString());

    timeoutId = setTimeout(() => {
        // Call the logout function after 60 minutes
        window.alert("Your session has timed out");
        window.location.href = "/login";
        sessionStorage.removeItem('sessionStartTime');
        sessionStorage.clear();
    }, sessionTimeout); // 60 minutes in milliseconds

};

export const clearTimer = () => {
    clearTimeout(timeoutId); // Clear the timeout when logging out
    clearTimeout(sessionTimeout);
};

export const loginService = async (data: Object) => {
    const res = await axios.post(host + baseUrl + tenant + api.loginApi, data, {
        headers: authHeader()
    });
    return res
};

export const loginAsService = async (userId: string) => {
    const res = await axios.post(host + baseUrl + tenant + api.loginAsApi + "?user_id=" + encodeURIComponent(userId), {}, {
        headers: authHeader()
    });
    return res
};

export const forgetPasswordService = async (data: { email: string }) => {
    const res = await axios.post(host + baseUrl + tenant + api.resetPassword, data, {
        headers: authHeader()
    });
    return res;
};

export const settingService = async () => {
    const res = await axios.get(settingsUrl,
        {
            params: { host: window.location.hostname }
        });
    return res
};

export const newCustomerEligibleService = async (data: NewCustomerEligibleArgs) => {
    const res = await axios.post(host + baseUrl + tenant + api.newCustomer + api.eligible, data, {
        headers: authHeader()
    });
    return res
};

export const newCustomerService = async (data: NewCustomerArgs) => {
    const res = await axios.post(host + baseUrl + tenant + api.newCustomer + api.register, data, {
        headers: authHeader()
    });
    return res
};

export const selfRegisterService = async (data: SelfRegisterArgs) => {
    const res = await axios.post(host + baseUrl + tenant + api.selfRegister, data, {
        headers: authHeader()
    });
    return res;
};

export const payAsGuestService = async (data: PayAsGuestArgs) => {
    const res = await axios.post(host + baseUrl + tenant + userApi.payment + api.guestPayment, data, {
        headers: authHeader()
    });
    return res;
};

export const logoutService = async () => {
    await axios.get(host + baseUrl + tenant + api.logoutApi, {
        headers: authHeader()
    })

    sessionStorage.removeItem('sessionStartTime');
    sessionStorage.clear();
};

export const verifyEmailService = async (userKey: string) => {
    const res = await axios.post(host + baseUrl + tenant + api.verifyEmail, {},
        {
            headers: { ...authHeader(), "user-key": userKey },
        });
    return res;
};

export const calculatePriceService = async (data: CalCulateOrderPrice) => {
    const res = await axios.post(host + baseUrl + tenant + api.newCustomer + userApi.fuelOrderPrice, data,
        {
            headers: authHeader()
        });
    return res;
};